import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Loading} from "../common";
import {useHistory} from "react-router-dom";
import AppRouters from "application/globals/app-routers";

const ReportCheckout = ({actions, isReportSync, report, ...others}) => {
  const history = useHistory();
  const [loading, setLoader] = useState(false);

  useEffect(() => {
    setLoader(true);
    if (!isReportSync) return actions.syncCurrentReport(history.location?.state?.reportId);

    if (!report) {
      console.log('Report was not persisted!');
      history.replace(AppRouters.incompletePaymentError);
    }
  }, [actions, report, isReportSync, history]);

  return (
    loading ? <Loading message="Procesando el pago ..."/> : <div/>
  );
};

const mapStateToProps = (state) => ({
  report: state.newRequest.data,
  isReportSync: state.newRequest.ui.isReportSync
});

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      syncCurrentReport: (reportId) => dispatch.newRequest.syncCurrentReportAction(reportId),
      onNewRequestAction: dispatch.newRequest.onNewRequestAction,
    },
    dispatch
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportCheckout);
